import { environment } from 'src/environments/environment';

export class UrlApi {
    public static URL_API = environment.apiUrl;
}